import Colcade from 'colcade'

// @see https://github.com/desandro/colcade
export default class Masonry {
  constructor(el) {
    let grid = new Colcade(el, {
      columns: '.grid-col',
      items: '.grid-item',
      // percentPosition: true
    });
  }
}
